module.exports = __webpack_public_path__ + "static/media/bills_of_landing_active_es.9c66f5b7.svg";